import { render, staticRenderFns } from "./Repayment.vue?vue&type=template&id=d60974d6&scoped=true"
import script from "./Repayment.vue?vue&type=script&lang=js"
export * from "./Repayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d60974d6",
  null
  
)

export default component.exports